"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DrivDinEgenFlotta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="driv-din-egen-flotta" className="relative w-full min-h-[70vh] flex items-end pb-24 pt-32 bg-background">
      {}
      <div className="absolute inset-0 z-0 overflow-hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592905/img/robotaxi_fleet_dashboard_charging.png" alt="Robotaxi flotta och laddstationer" className="w-full h-full object-cover object-center" />
        <div className="absolute inset-0 bg-black/60" />
      </div>

      {}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-8">
        <div ref={ref} className={`max-w-3xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Driv din egen flotta
          </h1>
          
          <p className="font-sans text-lg md:text-xl text-white/90 mb-10 max-w-2xl leading-relaxed">
            Upptäck potentialen i en skalbar passiv inkomst genom att hantera en egen flotta av självkörande taxibilar. Framtidens transport är autonom, och du kan vara med och bygga infrastrukturen i din stad från start.
          </p>
          
          <Link to="#intresseanmalan">
            <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-6 text-base font-medium rounded-[3px] shadow-md transition-colors">
              Anmäl intresse för din stad
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}